import {
    Box,
    Card,
    Flex,
    HStack,
    Skeleton,
    SkeletonCircle,
    VStack,
} from "@chakra-ui/react";

const skeletonProps = {
    bg: "#DAE9FF",
    borderRadius: "md",
};

const cardProps = {
    bg: "white",
    border: "none",
    borderWidth: 0,
    boxShadow: "sm",
    borderRadius: "20px",
};

const NotificationItem = () => (
    <Card.Root {...cardProps}>
        <Card.Body
            p={{
                base: 4,
                md: 6,
            }}
        >
            <Flex
                gap={4}
                align="flex-start"
            >
                <SkeletonCircle
                    bg="#DAE9FF"
                    size={{
                        base: "11",
                        md: "13",
                    }}
                    flexShrink={0}
                />

                <Box flex="1">
                    <HStack
                        justify="space-between"
                        align="flex-start"
                        flexWrap="wrap"
                        gap={2}
                        mb={3}
                    >
                        <Skeleton
                            {...skeletonProps}
                            h="10px"
                            w="90px"
                        />

                        <Skeleton
                            {...skeletonProps}
                            h="10px"
                            w="80px"
                        />
                    </HStack>

                    <Skeleton
                        {...skeletonProps}
                        h="18px"
                        w={{
                            base: "70%",
                            md: "240px",
                        }}
                        mb={3}
                    />

                    <Skeleton
                        {...skeletonProps}
                        h="12px"
                        w="100%"
                        mb={2}
                    />

                    <Skeleton
                        {...skeletonProps}
                        h="12px"
                        w={{
                            base: "95%",
                            md: "85%",
                        }}
                    />
                </Box>
            </Flex>
        </Card.Body>
    </Card.Root>
);

export default function NotificationsSkeleton() {
    return (
        <>
            {/* Header */}

            <Box
                mb={{
                    base: 6,
                    md: 8,
                }}
            >
                <Skeleton
                    {...skeletonProps}
                    h="36px"
                    w={{
                        base: "190px",
                        md: "260px",
                    }}
                    mb={3}
                />

                <Skeleton
                    {...skeletonProps}
                    h="16px"
                    w={{
                        base: "100%",
                        md: "420px",
                    }}
                    mb={6}
                />

                <Flex
                    justify={{
                        base: "flex-start",
                        md: "flex-end",
                    }}
                >
                    <Skeleton
                        {...skeletonProps}
                        h="18px"
                        w="120px"
                    />
                </Flex>
            </Box>

            {/* Notifications */}

            <VStack
                gap={4}
                align="stretch"
            >
                {Array.from({
                    length: 8,
                }).map((_, i) => (
                    <NotificationItem
                        key={i}
                    />
                ))}
            </VStack>
        </>
    );
}